import React from 'react';
import { config } from '../../config/jewelleryLandingConfig';

const TrustStrip = () => {
  const phoneHref = config.brand.phone.replace(/\s/g, '');

  return (
    <section className="bg-espresso text-ivory border-y border-champagne/20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-14">
        <div className="text-center">
          <p className="text-[10px] md:text-xs tracking-[0.24em] uppercase text-mutedGold mb-4">
            Independently Verify BPA Solutions
          </p>

          <h2 className="font-serif text-2xl md:text-3xl text-paper mb-4">
            Received an introductory call, email or message from us?
          </h2>

          <p className="max-w-3xl mx-auto text-sm md:text-base text-soft/75 font-light leading-relaxed">
            You are welcome to independently verify our business details before
            engaging with us. BPA Solutions will never ask for passwords,
            one-time codes, remote access or payment details during an
            introductory conversation.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          <div className="rounded-2xl border border-champagne/15 bg-white/5 px-4 py-4">
            <p className="text-[10px] tracking-[0.18em] uppercase text-mutedGold mb-2">
              Business
            </p>
            <p className="text-sm text-paper">
              BPA Solutions
            </p>
          </div>

          <div className="rounded-2xl border border-champagne/15 bg-white/5 px-4 py-4">
            <p className="text-[10px] tracking-[0.18em] uppercase text-mutedGold mb-2">
              Operated Through
            </p>
            <p className="text-sm text-paper">
              Anish Malhotra Pty Ltd
            </p>
          </div>

          <div className="rounded-2xl border border-champagne/15 bg-white/5 px-4 py-4">
            <p className="text-[10px] tracking-[0.18em] uppercase text-mutedGold mb-2">
              ABN
            </p>
            <p className="text-sm text-paper">
              83 679 369 932
            </p>
          </div>

          <div className="rounded-2xl border border-champagne/15 bg-white/5 px-4 py-4">
            <p className="text-[10px] tracking-[0.18em] uppercase text-mutedGold mb-2">
              Contact
            </p>
            <p className="text-sm text-paper">
              Anish Malhotra
            </p>
          </div>
        </div>

        <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-3 text-xs md:text-sm text-soft/75">
          <a
            href={`mailto:${config.brand.email}`}
            className="hover:text-gold transition-colors"
          >
            {config.brand.email}
          </a>

          <span className="hidden sm:inline text-champagne/30">•</span>

          <a
            href={`tel:${phoneHref}`}
            className="hover:text-gold transition-colors"
          >
            {config.brand.phone}
          </a>

          <span className="hidden sm:inline text-champagne/30">•</span>

          <a
            href="https://luxury.bpasolutions.au"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gold transition-colors"
          >
            luxury.bpasolutions.au
          </a>

          <span className="hidden sm:inline text-champagne/30">•</span>

          <span>{config.brand.location}</span>
        </div>

        <div className="mt-8 pt-7 border-t border-champagne/15 flex flex-wrap justify-center items-center gap-5 md:gap-8 text-center text-sm text-soft/70">
          <span>Done-for-you jewellery visuals</span>
          <span className="hidden md:block w-1.5 h-1.5 rounded-full bg-champagne/30" />
          <span>Built for ecommerce stores</span>
          <span className="hidden md:block w-1.5 h-1.5 rounded-full bg-champagne/30" />
          <span>Product pages, ads &amp; social</span>
          <span className="hidden lg:block w-1.5 h-1.5 rounded-full bg-champagne/30" />
          <span>Created by BPA Solutions</span>
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;